/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FiltersProp } from "~/models/estateRecordRow";
import { isNotEmpty } from "~/tools";
import { NumberRangeInput } from "./NumberRangeInput";

type Props = {
  filters: FiltersProp;
  setFilters: (input: FiltersProp) => void;
  size?: "m" | "s";
};

export function NumberRange({ filters, setFilters, size }: Props) {
  const handleChangeFrom = (value: string) => {
    const lifeSpanFrom = getValue(value);

    if (lifeSpanFrom === undefined || lifeSpanFrom >= 0) {
      setFilters({
        ...filters,
        lifeSpanFrom,
      });
    }
  };

  const handleChangeTo = (value: string) => {
    const lifeSpanTo = getValue(value);

    // Prevent entering two zeros, it messes-up the search service & returns wrong results
    if (lifeSpanTo === undefined || lifeSpanTo >= 1) {
      setFilters({
        ...filters,
        lifeSpanTo,
      });
    }
  };

  return (
    <NumberRangeInput
      from={filters.lifeSpanFrom}
      to={filters.lifeSpanTo}
      size={size}
      onChangeFrom={handleChangeFrom}
      onChangeTo={handleChangeTo}
    />
  );
}

function getValue(value: string): number | undefined {
  return isNotEmpty(value) ? Number(value) : undefined;
}
